import { FIELD_TYPE } from '../../constants.js'
import { makeInteger } from '../../utils'

export default function TotalsRow(props) {
  const { formInputs, printView } = props
  console.log('TotalsRow rendered: ', props)

  const currentValue = formInputs.currentValue
  const gridData = currentValue.gridData
  const details = currentValue.details
  let totalsColumns = null
  const sumColumns = []

  if (details) {
    for (let i = 0; i < details.length; i++) {
      if (details[i].sum === 'Y') {
        sumColumns.push({ field: details[i].field, columnNumber: i + 1, total: 0})
      }
    }

    for (let gridRow of gridData) {
      let rowObjectId = gridRow[0]
      for (let i = 0; i < sumColumns.length; i++) {
        let sumColumn = sumColumns[i]
        let gridValue = 0

        // first check currentValue[objectId]
        if (currentValue[rowObjectId]) {
          // value = 0 if marked for delete
          if (currentValue[rowObjectId].action && currentValue[rowObjectId].action.type.name === 'DELETE') {
            gridValue = 0
          } else {
            if (sumColumn.field.type.id === FIELD_TYPE.currency) {
              gridValue = currentValue[rowObjectId][sumColumns[i].field.id].currentValue * 100
            } else {
              gridValue = parseFloat(currentValue[rowObjectId][sumColumns[i].field.id].currentValue)
            }
          }
        } else {
          if (gridRow[sumColumn.columnNumber]) {
            let columnValue = gridRow[sumColumn.columnNumber]
            if (typeof columnValue !== 'number') {
              if (sumColumn.field.type.id === FIELD_TYPE.currency) {
                gridValue = parseFloat(columnValue.trim().replace('$', '').replace(/,/g, '')) * 100
              } else {
                //console.log('gridRow: ', gridRow, 'sumColumn: ', sumColumn, 'type: ', typeof columnValue)
                gridValue = parseFloat(columnValue.trim().replace(/,/g, ''))
              }
            } else {
              gridValue = columnValue
            }
          }
        }
        //console.log('------------------------- gridValue: ', gridValue, typeof gridValue)
        sumColumns[i].total += gridValue
      }
    }

    if (sumColumns.length > 0) {
      totalsColumns = []
      const colSpan = printView ? sumColumns[0].columnNumber - 1 : sumColumns[0].columnNumber
      totalsColumns.push(<td key={'Total'} style={{ textAlign: 'right', fontWeight: 'bold' }} colSpan={colSpan}>Total</td>)
      for (let i = 0; i < sumColumns.length; i++) {
        let sumColumn = sumColumns[i]
        let columnContent = sumColumn.total
        let formatter
        console.log('sumColumn.total: ', sumColumn.total)
        if (makeInteger(sumColumn.field.type.id) === FIELD_TYPE.currency) {
          formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
          columnContent = formatter.format(sumColumn.total/100)
        } else {
          formatter = new Intl.NumberFormat()
          columnContent = formatter.format(sumColumn.total)
        }
        totalsColumns.push(<td key={sumColumn.field.id} style={{ textAlign: 'right' }}>{columnContent}</td>)
      }
    }
  }

  return <tr>{totalsColumns}</tr>
}